import { action, thunkOn } from "easy-peasy";
import { message } from "antd";
import _ from "lodash";
import { onLogoutResolver } from "./on-logout-resolver";

export const NO_OPPS_MSG =
  "No opportunities available at this time. Please check " +
  "again tomorrow, as opportunities are sourced nightly.";

const modelOpportunities = {
  INITIAL_DATA_ENDPOINT: "opportunities",
  NAME: "opportunities",
  INCLUDE_APP_MODE_IN_INITIALDATA_REQUEST: true,
  INCLUDE_ITIN_MODE_IN_INITIALDATA_REQUEST: true,
  initialData: [],
  initialDataReceived: false,
  initialDataLoading: false,
  /////////////
  // ACTIONS //
  /////////////
  resetData: action((state) => {
    state.initialData = [];
    state.initialDataReceived = false;
    state.initialDataLoading = false;
  }),
  onLogout: thunkOn(onLogoutResolver, (actions) => {
    actions.resetData();
  }),
  onReportAction: thunkOn(
    (__, sa) => sa.actionReports.handleSubmitActionReport,
    async (actions) => {
      await actions.handleFetchInitialData();
    }
  ),
  receiveInitialData: action((state, payload) => {
    if (_.size(payload) === 0) {
      message.info(NO_OPPS_MSG, 0);
    }
    state.initialData = payload;
  }),
  maybeHandleFetchInitialData: undefined,
  handleFetchInitialData: undefined,
  markInitialDataReceived: undefined,
};

// function decrementNumFlopptionsForActionedTripLeg(rows, target) {
//   const { snapshot } = target.payload;
//   return rows.map(row => {
//     const isActionedTripLeg =
//       row.TripId === snapshot.TripId && row.leg_i === snapshot.leg_i;
//     if (isActionedTripLeg) {
//       return { ...row, num_flopptions: row.num_flopptions - 1 };
//     } else {
//       return row;
//     }
//   });
// }

export default modelOpportunities;
